var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-image-1 inner"},[_c('div',{staticClass:"text-image-1-text ecc",domProps:{"innerHTML":_vm._s(_vm.item.text)}}),_c('div',{staticClass:"text-image-1-image"},[_c('div',{directives:[{name:"bgimage",rawName:"v-bgimage",value:(_vm.item.image),expression:"item.image"}],staticClass:"text-image-1-image-image"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }